/* eslint-disable */
<template>
  <div class="admin-edit-client-contact">
    <AdminNavigation v-if="!clientIdProps" ref="navigation" indexProps="2"/>
    <div :class="{'top-panel' : !clientIdProps}" v-if="!clientIdProps">
      <Header/>
      <div v-if="contact !== undefined" class="header-title-section">
        <div class="header-title">
          <h1 v-if="!isNew">Edit Contact
            {{
              contact !== undefined ? decodeURIComponent(contact.FirstName + " " + (contact.MiddleName ? contact.MiddleName + " " : "") + contact.Surname) : ''
            }}</h1>
          <h1 v-else>Create New Contact</h1>
        </div>
        <div class="header-sub-title">View the details of a client contact.</div>
      </div>
    </div>
    <div :class="{'panel' : !clientIdProps}">
      <AdminClientsMenu v-if="!clientIdProps" :indexProps="3"/>
      <div :class="{'content': !clientIdProps}" class="d-flex">
        <div v-if="contact !== undefined" style="flex: 1">
          <div class="box">
            <div v-if="!clientIdProps" class="box-heading col-space-between d-flex justify-content-between align-center">
              <div>Contact details</div>
              <a class="ml-5 mr-0" @click.stop="" :href="contact.ZohoLink" target="_blank"><img src="@/assets/images/zoho_icon.svg"
                                                                                              data-placement="right" data-toggle="tooltip"
                                                                                              title="Link to Zoho"/></a>
            </div>
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">Client</div>
                <div class="box-col box-col-right ">
                  <el-select :disabled="clientId !== '' || user.type !== 6" class="w-50" @change="changeClients"
                             v-model="contact.ClientID" filterable remote :loading="loading"
                             :remote-method="remoteMethod"
                             :class="hasError && !validateClientContactClientIdField ? 'is-invalid' : ''">
                    <el-option v-for="item in clientList" :key="item.id" :value="item.ClientID"
                               :label="decodeURIComponent(`${item.ClientName} - ${item.BranchName}`)">
                    </el-option>
                  </el-select>
                  <div v-if="hasError && !validateClientContactClientIdField" class="text-danger">{{ clientFieldError }}</div>
                </div>
              </div>
              <div class="box-row" v-if="!isNew">
                <div class="box-col box-col-left">Branch</div>
                <div class="box-col box-col-right ">
                  <span>
                    {{ contact.BranchName }}
                  </span>
                </div>
              </div>
              <div class="box-row" v-if="!isNew && (user.type == 3 || user.type == 6)">
                <div class="box-col box-col-left">Active</div>
                <div class="box-col box-col-right">
                  <el-tooltip v-if="contact.IsPrimaryContact" effect="dark" placement="bottom">
                    <div v-if="contact.IsPrimaryContact" slot="content">Cannot deactivate as they are a primary user.
                      Select a new primary user before deactivating this account
                    </div>
                    <div style="width: fit-content">
                      <input :key="activeKey" type="checkbox"
                             :style="{cursor: contact.IsPrimaryContact ? 'not-allowed' : 'default'}"
                             :disabled="contact.IsPrimaryContact" v-model="contact.Active"/>
                    </div>
                  </el-tooltip>
                  <div v-else style="width: fit-content">
                    <input :key="activeKey" type="checkbox"
                           :style="{cursor: contact.IsPrimaryContact ? 'not-allowed' : 'default'}"
                           v-model="contact.Active"/>
                  </div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">First Name</div>
                <div class="box-col box-col-right">
                  <input type="text" v-model="contact.FirstName" maxlength="100"
                         :class="hasError && !validateContactFirstName ? 'is-invalid' : ''"
                         placeholder="Enter First Name"/>
                  <div autocomplete="new-password" v-if="hasError && !validateContactFirstName" class="text-danger">
                    {{ firstNameFieldError }}
                  </div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Middle Name</div>
                <div class="box-col box-col-right">
                  <input autocomplete="new-password" type="text" v-model="contact.MiddleName" maxlength="100"
                         :class="hasError && !validateMiddleName ? 'is-invalid' : ''"
                         placeholder="Enter Middle Name"/>
                  <div v-if="hasError && !validateMiddleName" class="text-danger">{{ middleNameFieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Surname</div>
                <div class="box-col box-col-right">
                  <input autocomplete="new-password" type="text" v-model="contact.Surname" maxlength="100"
                         :class="hasError && !validateContactSurname ? 'is-invalid' : ''"
                         placeholder="Enter Last Name"/>
                  <div v-if="hasError && !validateContactSurname" class="text-danger">{{ surnameFieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Salutation</div>
                <div class="box-col box-col-right">
                  <el-select class="w-50" v-model="contact.Salutation" filterable clearable
                             placeholder="Select Salutation"
                             :class="hasError && !validateSalutationField ? 'is-invalid' : ''">
                    <el-option v-for="item in salutationList" :key="item.value" :value="item.value"
                               :label="item.value"></el-option>
                  </el-select>
                  <div v-if="hasError && !validateSalutationField" class="text-danger">{{ salutationFieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Land Line</div>
                <div class="box-col box-col-right">
                  <input autocomplete="new-password" type="text" maxlength="12" v-model="contact.PhoneNumber1"
                         @blur="normalizePhoneField('PhoneNumber1')"
                         :class="hasError && !validatePhone1 ? 'is-invalid' : ''" placeholder="Enter Land Line"/>
                  <div v-if="hasError && !validatePhone1" class="text-danger">{{ phone1FieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Mobile</div>
                <div class="box-col box-col-right">
                  <input autocomplete="new-password" type="text" maxlength="12" v-model="contact.Mobile"
                         @blur="normalizePhoneField('Mobile')"
                         :class="hasError && !validateMobile ? 'is-invalid' : ''" placeholder="Enter Mobile"/>
                  <div v-if="hasError && !validateMobile" class="text-danger">{{ mobileFieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Work Phone</div>
                <div class="box-col box-col-right">
                  <input autocomplete="new-password" type="text" maxlength="12" v-model="contact.PhoneNumber2"
                         @blur="normalizePhoneField('PhoneNumber2')"
                         :class="hasError && !validatePhone2 ? 'is-invalid' : ''" placeholder="Enter Work Phone"/>
                  <div v-if="hasError && !validatePhone2" class="text-danger">{{ phone2FieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Email Address</div>
                <div class="box-col box-col-right">
                  <input autocomplete="new-password" type="text" v-model="contact.EmailAddress" maxlength="100"
                         :class="hasError && !validateContactEmail ? 'is-invalid' : ''"
                         placeholder="Enter Email Address"/>
                  <div v-if="hasError && !validateContactEmail" class="text-danger">{{ emailAddressFieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Notification Email Address</div>
                <div class="box-col box-col-right">
                  <input autocomplete="new-password" type="text" v-model="contact.NotificationEmailAddress" maxlength="100"
                         :class="hasError && !validateNotificationEmail ? 'is-invalid' : ''"
                         placeholder="Enter Email Address"/>
                  <div v-if="hasError && !validateNotificationEmail" class="text-danger">{{ notificationEmailFieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Role</div>
                <div class="box-col box-col-right">
                  <select class="textbox" v-model="contact.User.Role.UserRoleID"
                          :class="hasError && !validateUserRole ? 'is-invalid' : ''">
                    <option hidden value="">Please choose ...</option>
                    <option :value="1">Client</option>
                    <option :value="2">Branch Admin</option>
                  </select>
                  <div v-if="hasError && !validateUserRole" class="text-danger">{{ userRoleFieldError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">User Login?</div>
                <div class="box-col box-col-right">
                  <input type="checkbox" class="float-left row-item" v-model="contact.CanLogin" @change="onChangeLogin"/>
                  <v-btn v-if="showResend" class="ml-10 col-center-content"
                         style="background-color:#C4C4C4;color:#6686B6F" @click="reSendInvitation()"> Resend Invite
                  </v-btn>
                </div>
              </div>
              <div class="box-row" v-if="(user.type == 3 || user.type == 6)">
                <div class="box-col box-col-left">Primary Contact?</div>
                <div class="box-col box-col-right">
                  <input type="checkbox" :disabled="!!originalItem.IsPrimaryContact" v-model="contact.IsPrimaryContact"
                         @change="changeIsPrimaryContact($event)"/>
                </div>
              </div>
            </div>
            <AdminChangeOwnershipCasesModal ref="adminChangeOwnershipCasesModal"/>
          </div>
          <div class="alert alert-success alert-success-resend hidden-element">
            <a class="close" title="close">×</a>
            <b>Success:</b> {{ successMessage }}
          </div>
          <div class="alert alert-danger hidden-element">
            <a class="close" title="close">×</a>
            <b>Error:</b> {{ errorMessage }}
          </div>

          <div class="box-row item-right button-action">
<!--            <div v-if="contactId != ''">-->
<!--              <v-btn dark :class="cases.length == 0 ? 'disabled-element' : ''" @click="tapChangeOwnership">Change-->
<!--                Ownership of Case-->
<!--              </v-btn>-->
<!--            </div>-->
            <div class="ml-5">
              <v-btn :disabled="disableButton" dark @click="tapUpdateContact">{{ isNew ? 'Save' : 'Update' }}</v-btn>
            </div>
          </div>

          <div class="warning-alert alert alert-warning hidden-element">
            <a class="close" title="close">×</a>
            <b>Warning:</b> {{ errorMessage }}
            <v-btn class="alert-button ml-4" @click="tapCreate()">Save</v-btn>
            <v-btn class="alert-button ml-4" @click="tapCancel()">Cancel</v-btn>
          </div>

          <div class="warning-alert-zoho alert alert-warning hidden-element">
            <a class="close" title="close">×</a>
            <b>Warning:</b> {{ errorZohoMessage }}
            <v-btn class="alert-button ml-4" @click="tapZohoCancel()">Ok</v-btn>
          </div>
        </div>
        <div v-else>Contact does not exist</div>
        <div v-if="!clientIdProps" class="col-3 action-log d-inline-block m-0 p-0" style="vertical-align:top;">
          <div style="display: flex;flex-direction: row;">
            <span style="line-height: 3; padding-left: 20%">Contact Logs</span>
            <select @change="upDateLog($event)" class="ml-3 small-selector">
              <option value="0">Recent</option>
              <option value="1">View All</option>
            </select>
          </div>
          <Timeline :timeline="timelineData"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import Header from '@/components/Header'
import AdminClientsMenu from '@/components/AdminClientsMenu'
import AdminChangeOwnershipCasesModal from '@/components/AdminChangeOwnershipCasesModal'
import Timeline from '@/components/Timeline'

export default {
  name: 'AdminEditClientContact',
  props: ["searchOptionClientProps", "searchOptionContactProps", "clientIdProps"],
  components: {
    AdminNavigation,
    Header,
    AdminClientsMenu,
    AdminChangeOwnershipCasesModal,
    Timeline
  },
  data() {
    return {
      salutationList: utilities.initSalutation(),
      loading: false,
      clientList: [],
      zohoLink: [],
      hasError: false,
      successMessage: '',
      errorMessage: 'Please correct the errors shown above and try again.',
      errorZohoMessage: 'Could not create the contact in Zoho.',
      logParam: {
        pageNum: 1,
        pageSize: 10
      },
      clientId: '',
      contactId: '',
      contact: this.initContact(),
      originalItem: this.initContact(),
      allContacts: [],
      clients: [],
      cases: [],
      isNew: false,
      createContact: false,
      ignorName: false,
      showResend: false,
      disableButton: false,
      timelineData: [],
      activeKey: 0,
      originalClientId: '',
      originalClientDisplayName: '',
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    validateClientContactClientIdField() {
      const id = this.contact.ClientID
      return id !== undefined && id !== null && id !== ''
    },
    validateContactFirstName() {
      return utilities.validateClientContactPersonName(this.contact.FirstName)
    },
    validateContactSurname() {
      return utilities.validateClientContactPersonName(this.contact.Surname)
    },
    validateMiddleName() {
      return utilities.validateClientContactMiddleName(this.contact.MiddleName)
    },
    validateSalutationField() {
      return utilities.validateClientContactSalutation(this.contact.Salutation)
    },
    validateUserRole() {
      const roleId = this.contact.User && this.contact.User.Role ? this.contact.User.Role.UserRoleID : undefined
      return utilities.validateClientContactUserRoleId(roleId)
    },
    validateContactEmail() {
      return utilities.validateClientContactEmail(this.contact.EmailAddress, true)
    },
    validateNotificationEmail() {
      return utilities.validateClientContactEmail(this.contact.NotificationEmailAddress, false)
    },
    validateMobile() {
      const s = String(this.contact.Mobile || '').trim()
      const needLogin = this.contact.CanLogin == 1 || this.contact.CanLogin === true
      if (needLogin && !s) {
        return false
      }
      if (!s) {
        return true
      }
      return utilities.validateClientContactPhoneAu12(s)
    },
    validatePhone1() {
      const s = String(this.contact.PhoneNumber1 || '').trim()
      if (!s) {
        return true
      }
      return utilities.validateLandPhone(s)
    },
    validatePhone2() {
      const s = String(this.contact.PhoneNumber2 || '').trim()
      if (!s) {
        return true
      }
      return utilities.validateLandPhone(s)
    },
    firstNameFieldError() {
      if (this.validateContactFirstName) return ''
      return utilities.getClientContactPersonNameError(this.contact.FirstName, 'First name')
    },
    surnameFieldError() {
      if (this.validateContactSurname) return ''
      return utilities.getClientContactPersonNameError(this.contact.Surname, 'Surname')
    },
    middleNameFieldError() {
      if (this.validateMiddleName) return ''
      return utilities.getClientContactMiddleNameError(this.contact.MiddleName)
    },
    salutationFieldError() {
      if (this.validateSalutationField) return ''
      return utilities.getClientContactSalutationError(this.contact.Salutation)
    },
    clientFieldError() {
      if (this.validateClientContactClientIdField) return ''
      return 'Client is required. Select a client from the list.'
    },
    userRoleFieldError() {
      if (this.validateUserRole) return ''
      return 'Role is required. Choose Client or Branch Admin.'
    },
    phone1FieldError() {
      if (this.validatePhone1) return ''
      return 'Enter a valid land line (6-digit 13…, or use + and digits as required).'
    },
    phone2FieldError() {
      if (this.validatePhone2) return ''
      return 'Enter a valid work number (6-digit 13…, or use + and digits as required).'
    },
    mobileFieldError() {
      if (this.validateMobile) return ''
      const s = String(this.contact.Mobile || '').trim()
      const needLogin = this.contact.CanLogin == 1 || this.contact.CanLogin === true
      if (needLogin && !s) {
        return 'Mobile is required when user login access is enabled.'
      }
      return utilities.getClientContactPhoneAu12Error(this.contact.Mobile, 'Mobile')
    },
    emailAddressFieldError() {
      if (this.validateContactEmail) return ''
      return utilities.getClientContactEmailError(this.contact.EmailAddress, 'Email address', true)
    },
    notificationEmailFieldError() {
      if (this.validateNotificationEmail) return ''
      return utilities.getClientContactEmailError(this.contact.NotificationEmailAddress, 'Notification email address', false)
    },
  },
  methods: {
    normalizePhoneField(field) {
      const raw = this.contact[field]
      if (raw === undefined || raw === null || String(raw).trim() === '') {
        this.contact[field] = ''
        return
      }
      this.contact[field] = utilities.normalizeAuPhoneInput(raw)
    },
    onChangeLogin(e) {
      if(e.target.checked) {
        this.contact.CanLogin = 1
      } else {
        this.contact.CanLogin = 0
      }
    },
    changeClients(value) {
      this.client = this.clientList.find(item => item.ClientID === value)
      this.contact.BranchName = this.client.BranchName
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        const param = {
          ClientName: query,
          pageSize: 100,
          pageNum: 1,
        }
        const r = await utilities.getClientsNew(param)
        this.clientList = r.clients
        console.log(this.clientList)
      } else {
        this.clientList = [this.client]
      }
      this.loading = false;
    },
    tapCancel() {
      $('.warning-alert').hide()
      this.createContact = false
    },

    tapCreate() {
      this.createContact = true
      $('.warning-alert').hide()
      this.callCreateContact()
    },

    tapZohoCancel() {
      $('.warning-alert-zoho').hide()
      window.history.replaceState({}, document.title, location.pathname + location.search + "&contactId=" + this.contact.clientContactId)
      setTimeout(() => {
        location.reload()
      }, 300)
    },

    setSuccessMessage(status) {
      if (status == 200) {
        this.successMessage = "Successfully moved case ownership!"
        utilities.showAlert(".alert-success-resend")
      } else if (status == 400) {
        this.errorMessage = "No cases for this client contact."
        utilities.showAlert(".alert-danger")
      }
    },
    initContact() {
      return {
        clientContactId: '',
        Mobile: '',
        Surname: '',
        CanLogin: false,
        FirstName: '',
        MiddleName: '',
        EmailAddress: '',
        PhoneNumber1: '',
        PhoneNumber2: '',
        IsPrimaryContact: false,
        userRoleId: 1,
        Active: true,
        fullName: '',
        NotificationEmailAddress: '',
        Salutation: '',
        User: {
          Role: {
            UserRoleID: 1,
          },
        }
      }
    },
    changeIsPrimaryContact(e) {
      if(e.target.checked) {
        this.contact.IsPrimaryContact = 1
      } else {
        this.contact.IsPrimaryContact = 0
      }
      if (this.contact.IsPrimaryContact && !this.contact.Active) {
        this.contact.Active = true
        this.activeKey += 1
      }
    },
    tapChangeOwnership() {
      if (this.cases.length == 0) return
      this.$refs.adminChangeOwnershipCasesModal.handleModal()
      console.log(this.contact)
      this.$refs.adminChangeOwnershipCasesModal.fromId = this.contact.clientContactId
      this.$refs.adminChangeOwnershipCasesModal.contactName = this.contact.fullName
      this.$refs.adminChangeOwnershipCasesModal.setCaseOwners(this.client.contacts.filter((x) => x.userId != this.contact.userId))
    },

    validateClientEmail() {
      if (!this.isNew) {
        return true
      }
      if (this.allContacts.map(x => {
        return x.EmailAddress
      }).includes(this.contact.EmailAddress)) {
        this.errorMessage = 'Email Address Already Exists!'
        utilities.showAlert('.alert-danger')
        this.createContact = false
        return false
      }
      return true
    },

    async validateContactName(ignorName) {
      if (!this.isNew) {
        return true
      }
      var isExists = false
      this.allContacts.map((x) => {
        if (x.FirstName.toUpperCase() === this.contact.FirstName.toUpperCase() && x.MiddleName === this.contact.MiddleName && x.Surname.toUpperCase() === this.contact.Surname.toUpperCase()) {
          this.errorMessage = 'The entered contact name already exists. Do you wish to continue?'
          utilities.showAlert('.warning-alert', false)
          isExists = true
          return
        }
      })
      if (isExists) {
        return false
      } else {
        return true
      }

    },

    async tapUpdateContact() {
      this.errorMessage = 'Please correct the errors shown above and try again.'
      this.normalizePhoneField('PhoneNumber1')
      this.normalizePhoneField('Mobile')
      this.normalizePhoneField('PhoneNumber2')
      if (!this.validateClientContactClientIdField || !this.validateContactFirstName || !this.validateContactSurname || !this.validateMiddleName || !this.validateSalutationField || !this.validateUserRole || !this.validateContactEmail || !this.validateNotificationEmail || !this.validateMobile || !this.validatePhone1 || !this.validatePhone2) {
        this.hasError = true
        utilities.showAlert('.alert-danger')
        return
      }

      if (!this.validateClientEmail() || !await this.validateContactName()) {
        this.createContact = false
        return
      } else {
        this.createContact = true
      }
      //call API
      if (this.createContact) {
        const moveResult = await this.confirmDisableOriginalClientIfLastContact()
        if (moveResult === null) {
          this.createContact = false
          return
        }
        await this.callCreateContact(moveResult.disableOriginalClient)
      }
      this.createContact = false
    },

    /**
     * When moving contact to another client:
     * - only contact + active bookings → block
     * - only contact + no active bookings → confirm then disable old client (existing)
     * - not only contact + active bookings → confirm with affected bookings before update
     * @returns {{disableOriginalClient: boolean}|null} null = cancelled/blocked
     */
    async confirmDisableOriginalClientIfLastContact() {
      if (this.isNew || !this.originalClientId) {
        return { disableOriginalClient: false }
      }
      if (String(this.contact.ClientID) === String(this.originalClientId)) {
        return { disableOriginalClient: false }
      }

      await this.$store.dispatch('loading/setLoadComponent', true)
      try {
        const contactsResult = await utilities.getClientContactsNew({
          ClientID: this.originalClientId,
          pageNum: 1,
          pageSize: 1,
        })
        const total = contactsResult && contactsResult.total != null
          ? Number(contactsResult.total)
          : (contactsResult && contactsResult.contacts ? contactsResult.contacts.length : 0)
        const isOnlyContact = total === 1
        const activeBookings = await this.getActiveBookingsForContact(this.contactId)
        if (activeBookings === null) {
          await this.$store.dispatch('loading/setLoadComponent', false)
          return null
        }
        const hasActiveBookings = activeBookings.length > 0
        await this.$store.dispatch('loading/setLoadComponent', false)

        const clientLabel = this.originalClientDisplayName || ('Client ID ' + this.originalClientId)

        if (hasActiveBookings && isOnlyContact) {
          try {
            await this.$msgbox({
              title: 'Warning',
              message: `This contact is the only contact for client "${clientLabel}" and is associated with active bookings. Moving is not allowed. Another Client Contact must first be created or associated with the old Client.`,
              showCancelButton: false,
              confirmButtonText: 'OK',
            })
          } catch (e) { /* closed */ }
          return null
        }

        if (!hasActiveBookings && isOnlyContact) {
          try {
            await this.$msgbox({
              title: 'Warning',
              message: `This is the only contact for client "${clientLabel}". If you move this contact away, that client will be disabled. Do you want to continue?`,
              showCancelButton: true,
              confirmButtonText: 'Continue',
              cancelButtonText: 'Cancel',
            })
            return { disableOriginalClient: true }
          } catch (e) {
            return null
          }
        }

        if (hasActiveBookings && !isOnlyContact) {
          const bookingLinksHtml = this.buildActiveBookingLinksHtml(activeBookings)
          try {
            await this.$msgbox({
              title: 'Warning',
              dangerouslyUseHTMLString: true,
              message: 'You are about to move this contact to another client. The following booking(s) will be affected. Do you want to continue?<br/>' +
                'After you continue, you will receive an email reminder about the affected booking(s). Please check your email.<br/>' +
                '<div style="margin-top:8px;max-height:240px;overflow:auto;">' + bookingLinksHtml + '</div>',
              showCancelButton: true,
              confirmButtonText: 'Continue',
              cancelButtonText: 'Cancel',
            })
            return { disableOriginalClient: false }
          } catch (e) {
            return null
          }
        }

        return { disableOriginalClient: false }
      } catch (e) {
        await this.$store.dispatch('loading/setLoadComponent', false)
        return null
      }
    },

    async getActiveBookingsForContact(clientContactId) {
      const inactiveStatuses = ['6', '7', '11', '12', '13', '14', '15']
      const result = await utilities.getAllBookingsNew({
        ClientContactID: clientContactId,
        pageNum: 1,
        pageSize: 999,
      })
      if (!result) {
        return null
      }
      const bookings = result.bookings || []
      return bookings.filter(booking => !inactiveStatuses.includes(String(booking.BookingStatus)))
    },

    buildActiveBookingLinksHtml(bookings) {
      return bookings.map(booking => {
        const href = this.$router.resolve({
          name: 'admin-manage-booking',
          query: { id: booking.BookingID },
        }).href
        return '<div><a href="' + href + '" target="_blank" rel="noopener noreferrer">Booking #' + booking.BookingID + '</a></div>'
      }).join('')
    },

    async disableOriginalClientAfterMove() {
      const clientId = this.originalClientId
      const clientLabel = this.originalClientDisplayName || ('Client ID ' + clientId)
      const result = await utilities.deActiveClient(clientId, { Action: 'Deactivate' }, { silent: true })
      if (!result) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-danger">' +
            '<b>Error:</b> Contact was moved successfully, but failed to disable client "' + clientLabel +
            '". Please disable that client manually.' +
            '</div>',
        })
      }
    },

    upDateLog(e) {
      if (e.target.value === '1') {
        this.logParam.pageSize = 999
      } else {
        this.logParam.pageSize = 10
      }
      this.getLogs()
    },

    async callCreateContact(disableOriginalClient = false) {
      this.$store.dispatch('loading/setLoadComponent', true)
      this.contact.fullName = this.contact.FirstName + ' ' + (this.contact.MiddleName == '' ? '' : this.contact.MiddleName + ' ') + this.contact.Surname
      var number = utilities.updateMobileCode(utilities.validatePhonenumber(utilities.normalizeAuPhoneInput(this.contact.Mobile)))
      var params = {
        Mobile: utilities.validatePhonenumber(number),
        Surname: this.contact.Surname,
        Salutation: this.contact.Salutation,
        CanLogin: this.contact.CanLogin ? 1 : 0,
        FirstName: this.contact.FirstName,
        MiddleName: this.contact.MiddleName,
        EmailAddress: this.contact.EmailAddress,
        NotificationEmailAddress: this.contact.NotificationEmailAddress,
        PhoneNumber1: utilities.validatePhonenumber(utilities.normalizeAuPhoneInput(this.contact.PhoneNumber1)),
        PhoneNumber2: utilities.validatePhonenumber(utilities.normalizeAuPhoneInput(this.contact.PhoneNumber2)),
        IsPrimaryContact: this.contact.IsPrimaryContact,
        UserRoleID: this.contact.User.Role.UserRoleID,
        Active: this.contact.Active ? 1 : 0,
      }
      if (this.contact.contactUserId != undefined && this.contact.contactUserId != '')
        params.ContactUserID = this.contact.contactUserId

      params.ClientID = this.contact.ClientID

      var result = ""
      for (let key in params) {
        if (params[key] === null || params[key] === '') {
          delete params[key];
        }
      }
      if (this.isNew) { // Add new contact
        result = await utilities.postContact(params)
        if (result) {
          this.successMessage = 'Client contact created successfully'
          utilities.showAlert('.alert-success-resend')

          if (this.clientIdProps) {
            await this.$store.dispatch('loading/setLoadComponent', false)
            this.contact = this.initContact()
            this.contact.ClientID = this.clientIdProps
            this.$emit('contactCreated')
            return
          }
          window.history.replaceState({}, document.title, location.pathname + "?id=" + result)
          setTimeout(() => {
            location.reload()
          }, 1000)

        }
      } else {  // Edit contact
        result = await utilities.putContact(this.contactId, params)
        if (result) {

          if (this.contact.CanLogin) {
            this.showResend = true
          } else {
            this.showResend = false
          }
          this.originalItem = _.cloneDeep(this.contact)
          this.successMessage = 'Contacts updated.'
          utilities.showAlert('.alert-success')
          if (disableOriginalClient) {
            await this.disableOriginalClientAfterMove()
          }
        }
      }
      this.createContact = false
      await this.loadData()
      this.$store.dispatch('loading/setLoadComponent', false)
    },

    async reSendInvitation() {
      const normalizedMobile = utilities.normalizeAuPhoneInput(this.contact.Mobile)
      this.contact.Mobile = normalizedMobile
      if (!utilities.validateClientContactPhoneAu12(normalizedMobile)) {
        this.hasError = true
        utilities.showAlert('.alert-danger')
        return
      }

      var mobile = utilities.updateMobileCode(utilities.validatePhonenumber(normalizedMobile))
      if (mobile.charAt(0) == '0') {
        mobile = mobile.substring(1)
      }
      this.$store.dispatch('loading/setLoadComponent', true)
      var params = {
        Name: this.contact.fullName,
        EmailAddress: this.contact.EmailAddress,
        Mobile: mobile,
        UserRoleID: this.contact.User.Role.UserRoleID,
      }
      var result = await utilities.postResendInvite(this.contact.UserID, params)
      if (result) {
        this.successMessage = 'Invitation resent successfully'
        utilities.showAlert(".alert-success-resend")
      }
      this.$store.dispatch('loading/setLoadComponent', false)
    },
    async getLogs() {
      if(!this.contactId) return
      this.timelineData = []
      const logs = await utilities.getClientContactLogs(this.logParam)
      const sortedLogs = [...logs].sort((a, b) => Number(b.ClientContactLogID) - Number(a.ClientContactLogID))
      sortedLogs.map((x) => {
        let timeline = {
          id: x.ClientContactLogID,
          userName: decodeURIComponent(x.Username),
          datetime: utilities.formatDate(x.LogDate, 'DD/MM/YYYY hh:mm A', "YYYY-MM-DD HH:mm:ss.ssssss"),
          body: decodeURIComponent(x.LogDetails),
        }
        this.timelineData.push(timeline)
      })
    },
    async loadData() {
      const contacts = await utilities.getClientContactById(this.contactId)
      this.contact = contacts || null
      if (!this.contact) {
        return
      }
      if (!this.contact.User) {
        this.contact.User = {
          Role: {
            UserRoleID: 1,
          },
        }
      }
      if (!this.contact.User.Role) {
        this.contact.User.Role = { UserRoleID: 1 }
      }
      if (this.contact.User.Role.UserRoleID === undefined || this.contact.User.Role.UserRoleID === null || this.contact.User.Role.UserRoleID === '') {
        this.contact.User.Role.UserRoleID = 1
      }
      this.originalItem = _.cloneDeep(this.contact)

      this.contact.Surname = decodeURIComponent(this.contact.Surname)
      this.contact.MiddleName = decodeURIComponent(this.contact.MiddleName)
      this.contact.FirstName = decodeURIComponent(this.contact.FirstName)
      const apiArr = [utilities.getClientById(this.contact.ClientID)]
      const r = await Promise.all(apiArr)

      this.client = r[0]
      this.client.ClientID = this.client.id
      this.client.BranchName = this.client.branchName
      this.client.ClientName = this.client.name
      this.clientList.push(this.client)
      this.originalClientId = this.contact.ClientID
      this.originalClientDisplayName = decodeURIComponent(
        this.client.branchName ? (this.client.name + ' - ' + this.client.branchName) : this.client.name
      )
      if (this.contact.CanLogin) {
        this.showResend = true
      } else {
        this.showResend = false
      }
    },
    async createNewContact() {
      this.contact = this.initContact()
      this.contact.ClientID = this.client.id
      this.contact.ClientName = this.client.name
      this.contact.BranchName = this.client.branchName
      this.isNew = true
      if (this.client.contacts.length === 0) {
        this.contact.IsPrimaryContact = true
      }
    },
  },
  async beforeMount() {
    await this.$store.dispatch('loading/setLoadComponent', true)
    this.clientId = this.$route.query.clientId !== undefined ? this.$route.query.clientId : ''
    this.contactId = this.$route.query.id !== undefined ? this.$route.query.id : ''
    this.logParam.ClientContactID = this.contactId
    if (this.clientIdProps) {
      this.clientId = this.clientIdProps
    }
    this.getLogs()
    if (this.clientId !== '') {
      this.allContacts = await utilities.getClientContacts(this.clientId)
      this.allContacts.map(x => {
        x.Mobile = utilities.removeMobileCode(x.Mobile)
      })
      this.zohoLink = this.contactId ? this.allContacts.filter(item => item.clientContactId.toString() === this.contactId.toString()) : ''
      this.client = await utilities.getClientById(this.clientId)
      this.client.ClientID = this.client.id
      this.client.BranchName = this.client.branchName
      this.client.ClientName = this.client.name
      this.clientList.push(this.client)
      this.contact.ClientID = this.client.id
    }
    if (this.contactId !== '') { // Edit contact
      await this.loadData()
    } else if (this.clientId !== '' && this.contactId === '') {  // Add new contact
      await this.createNewContact()
      this.showResend = false
    } else {
      this.contact = undefined
      this.showResend = false
    }
    await this.$store.dispatch('loading/setLoadComponent', false)
  },
  mounted() {
  },
}
</script>
